
export const PublicPageLayout = {
	PLAIN: 0,//コメント・説明欄なしレイアウト
	STANDARD: 10,//コメント・説明欄ありレイアウト。これ以降はコメントありレイアウトとしたい
} as const;

type PublicPageLayout = typeof PublicPageLayout
export type PublicPageLayoutEnum = PublicPageLayout[keyof PublicPageLayout]


